const TEST_ID = {
  RESULT_CONTAINER: 'result-container',
  POPULAIR_SEARCH: 'populair-search',
  INTRO_SEARCH: 'intro-search',
  SCREEN_READER_BUTTON: 'screen-reader-button',
};

export { TEST_ID as default };
